(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/helpers/normalize-wager.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/helpers/normalize-wager.js');
"use strict";

const _excluded = ["systemNum", "boardProps", "systemType"],
  _excluded2 = ["systemNum", "boardProps", "systemType"],
  _excluded3 = ["betProperties", "er1X2BoardData", "game1X2Boards", "scoreBoards", "erScoreBoardData", "expertenBoardData"],
  _excluded4 = ["currentAddonDrawNumber", "currentDrawNumber", "extraDescription", "productId", "systemType", "wager", "wins", "completedDraws"],
  _excluded5 = ["drawNum"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const products = svs.utils.products;
const isAddonWagerByITSName = svs.components.sport.tipsenShared.isAddonWagerByITSName;
const wagerSystemTypes = svs.components.tipsen.engine.constants.wagerSystemTypes;
const getDefinitionByProduct = svs.components.tipsen.engine.utils.getDefinitionByProduct;
const _svs$components$tipse = svs.components.tipsen.expandedSystems,
  getOutcomeDistributionMatrix = _svs$components$tipse.getOutcomeDistributionMatrix,
  expandScoreboardToSign = _svs$components$tipse.expandScoreboardToSign,
  expandScoreboardOutcomePairsToSrowHex = _svs$components$tipse.expandScoreboardOutcomePairsToSrowHex,
  expandOutcomePairsToSigns = _svs$components$tipse.expandOutcomePairsToSigns;
const compressSROWToHex = svs.components.tipsen.expandedSystems.utils.compressSROWToHex;
const getLogger = svs.core.log.getLogger;
const helpers = svs.components.tipsen.store.helpers;
const utils = svs.components.tipsen.expandedSystems.utils;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const logger = getLogger('store:normalize-wager');
const outcomeMap = {
  1: 0,
  X: 1,
  2: 2
};

const translateCompletedDrawProductId = productId => {
  const productName = productId.trim().toLowerCase();
  switch (productName) {
    case 'topptipsetextra':
      return 'topptipset';
    default:
      return productId;
  }
};
const ER_BOARDS = [wagerSystemTypes.REDUCERA_FRITT, wagerSystemTypes.OWNROWS];
const MSYS_LIKE_BOARDS = [wagerSystemTypes.MSYS, wagerSystemTypes.RSYS, wagerSystemTypes.USYS];
const EXPERTEN_BOARDS = [wagerSystemTypes.XPERTEN];
const convertDistributionMatrixToIndex = distributionMatrix => {
  const signs = distributionMatrix.map(event => {
    const convSigns = [];
    event.forEach((betValue, index) => {
      if (betValue > 0) {
        convSigns.push(index);
      }
    });
    return [convSigns];
  });
  return signs;
};
const convertboardDataToIndex = (board, eventTypeId) => {
  const outcomeCount = utils.getOutcomeCountForEvent(eventTypeId);
  if (!outcomeCount) {
    throw new Error("Unknown eventTypeId: ".concat(eventTypeId));
  }
  if (eventTypeId === EventTypeId.GOAL_COUNT) {
    const goalCountSigns = board.map(row => [row.map(value => parseInt(value, 10))]);
    return [goalCountSigns];
  }
  const mSigns = [];
  const signs = [];
  board.forEach(row => {
    mSigns.push(row.includes('M'));
    signs.push([row.replace('M', '').split('').map(n => utils.outcomeMap[n])]);
  });
  return [signs, mSigns];
};
const normalizeScoreBoard = _ref => {
  let betBoards = _ref.betBoards,
    _ref$betProperties = _ref.betProperties,
    betProperties = _ref$betProperties === void 0 ? [] : _ref$betProperties,
    productBet = _ref.productBet,
    systemType = _ref.systemType;
  const boards = betBoards.find(board => board.systemType.includes(systemType));
  const systemNum = boards.systemNum,
    boardProps = boards.boardProps,
    _systemType = boards.systemType,
    restOutcomes = _objectWithoutProperties(boards, _excluded);
  const gameBoard = _objectSpread({
    boards: {
      betProperties: betProperties || [],
      boardProps: boardProps || [],
      systemType,
      systemNum
    }
  }, productBet);
  const _expandScoreboardToSi = expandScoreboardToSign(restOutcomes),
    _expandScoreboardToSi2 = _slicedToArray(_expandScoreboardToSi, 2),
    signs = _expandScoreboardToSi2[0],
    reduction = _expandScoreboardToSi2[1];
  gameBoard.boards.boardData = {
    signs,
    reduction
  };
  return gameBoard;
};
const normalizeBetBoard = (outcomes, uRow, productId) => {
  let uRowOutcomes = [];
  const eventTypeId = getDefinitionByProduct(productId).outcomes.eventTypeId;
  if (uRow) {
    uRowOutcomes = uRow.boardData.map(outcome => {
      var _outcomeMap$outcome;
      return (_outcomeMap$outcome = outcomeMap[outcome]) !== null && _outcomeMap$outcome !== void 0 ? _outcomeMap$outcome : null;
    });
  }
  const _convertboardDataToIn = convertboardDataToIndex(outcomes.boardData, eventTypeId),
    _convertboardDataToIn2 = _slicedToArray(_convertboardDataToIn, 2),
    signs = _convertboardDataToIn2[0],
    mSigns = _convertboardDataToIn2[1];
  return [signs, mSigns, uRowOutcomes];
};
const expandSystemToDistributionMatrix = _ref2 => {
  let outcomeMatrix = _ref2.outcomeMatrix,
    mSigns = _ref2.mSigns,
    uRowOutcomes = _ref2.uRowOutcomes,
    productId = _ref2.productId,
    systemType = _ref2.systemType,
    systemNum = _ref2.systemNum;
  const eventTypeId = getDefinitionByProduct(productId).outcomes.eventTypeId;
  const srows = helpers.getExpandedRows({
    signs: outcomeMatrix,
    mSigns,
    uSigns: uRowOutcomes
  }, systemType, systemNum, {
    eventTypeId
  });
  const distributionMatrix = getOutcomeDistributionMatrix(srows, {
    eventTypeId
  });
  return distributionMatrix;
};
const normalizeErBoards = _ref3 => {
  let betBoards = _ref3.betBoards,
    productBet = _ref3.productBet,
    _ref3$betProperties = _ref3.betProperties,
    betProperties = _ref3$betProperties === void 0 ? [] : _ref3$betProperties,
    productId = _ref3.productId,
    systemType = _ref3.systemType;
  const eventTypeId = getDefinitionByProduct(productId).outcomes.eventTypeId;
  const boards = betBoards.boards;
  const systemNum = null;
  if (!systemType) {
    systemType = {
      true: wagerSystemTypes.SROW,
      false: wagerSystemTypes.MSYS
    }[betBoards.simpleRowsOnly];
  }
  const srows = helpers.getExpandedRows({
    boards
  }, systemType, systemNum, {
    eventTypeId
  });
  const distributionMatrix = getOutcomeDistributionMatrix(srows, {
    eventTypeId
  });
  const signs = convertDistributionMatrixToIndex(distributionMatrix);
  const gameBoard = _objectSpread({
    boards: {
      betProperties,
      boardProps: [],
      systemType,
      systemNum
    }
  }, productBet);
  gameBoard.boards.boardData = {
    signs,
    boards,
    simpleRowsOnly: betBoards.simpleRowsOnly,
    distribution: distributionMatrix
  };
  return gameBoard;
};
const normalizeErBoardsScore = _ref4 => {
  let betBoards = _ref4.betBoards,
    _ref4$betProperties = _ref4.betProperties,
    betProperties = _ref4$betProperties === void 0 ? [] : _ref4$betProperties,
    productBet = _ref4.productBet,
    eventTypeId = _ref4.eventTypeId;
  const systemType = undefined;
  const systemNum = undefined;
  const srows = helpers.getExpandedRows({
    boards: betBoards.boards
  }, systemType, systemNum, {
    eventTypeId,
    shouldExpandERScoreBoardToSROWHex: true
  });
  const gameBoard = _objectSpread({
    boards: {
      betProperties: betProperties || []
    }
  }, productBet);
  gameBoard.boards.boardData = {
    boards: srows
  };
  return gameBoard;
};
const normalizeSROWBoards = _ref5 => {
  let betBoards = _ref5.betBoards,
    betProperties = _ref5.betProperties,
    productBet = _ref5.productBet,
    systemType = _ref5.systemType,
    productId = _ref5.productId;
  const eventTypeId = getDefinitionByProduct(productId).outcomes.eventTypeId;
  const _betBoards$reduce = betBoards.reduce((_ref6, board) => {
      let _ref7 = _slicedToArray(_ref6, 4),
        boardData = _ref7[0],
        boardProps = _ref7[1],
        systemTypes = _ref7[2],
        systemNum = _ref7[3];
      return [[...boardData, compressSROWToHex(board.boardData, {
        eventTypeId
      })], [...boardProps, board.boardProps], [...systemTypes, board.systemType], [...systemNum, board.systemNum]];
    }, [[], [], [], []]),
    _betBoards$reduce2 = _slicedToArray(_betBoards$reduce, 1),
    boardDatas = _betBoards$reduce2[0];
  return normalizeErBoards({
    betBoards: {
      boards: boardDatas
    },
    productBet,
    betProperties: (betProperties || []).concat(wagerSystemTypes.ENKELRADER),
    productId,
    systemType
  });
};
const normalizeMURBoards = _ref8 => {
  let betBoards = _ref8.betBoards,
    _ref8$betProperties = _ref8.betProperties,
    betProperties = _ref8$betProperties === void 0 ? [] : _ref8$betProperties,
    productBet = _ref8.productBet,
    systemType = _ref8.systemType,
    productId = _ref8.productId;
  const outcomes = betBoards.find(board => board.systemType.includes(systemType));
  const uRow = betBoards.find(board => board.systemType.includes(wagerSystemTypes.UROW));
  const systemNum = outcomes.systemNum,
    boardProps = outcomes.boardProps,
    _systemType = outcomes.systemType,
    restOutcomes = _objectWithoutProperties(outcomes, _excluded2);
  const _normalizeBetBoard = normalizeBetBoard(restOutcomes, uRow, productId, systemType, systemNum),
    _normalizeBetBoard2 = _slicedToArray(_normalizeBetBoard, 3),
    signs = _normalizeBetBoard2[0],
    mSigns = _normalizeBetBoard2[1],
    uSigns = _normalizeBetBoard2[2];
  const distribution = expandSystemToDistributionMatrix({
    outcomeMatrix: signs,
    mSigns,
    uRowOutcomes: uSigns,
    productId,
    systemType,
    systemNum
  });
  const gameBoard = _objectSpread({
    boards: {
      betProperties: betProperties || [],
      boardProps: boardProps || [],
      systemType,
      systemNum
    }
  }, productBet);
  gameBoard.boards.boardData = {
    signs,
    mSigns,
    uSigns,
    distribution
  };
  return gameBoard;
};
const normalizeScoreBoardWithOutcomePairs = _ref9 => {
  let betBoards = _ref9.betBoards,
    _ref9$betProperties = _ref9.betProperties,
    betProperties = _ref9$betProperties === void 0 ? [] : _ref9$betProperties,
    productBet = _ref9.productBet,
    eventTypeId = _ref9.eventTypeId,
    systemType = _ref9.systemType;
  const boards = expandScoreboardOutcomePairsToSrowHex(betBoards, eventTypeId);
  const gameBoard = _objectSpread({
    boards: {
      betProperties: betProperties || [],
      systemType
    }
  }, productBet);
  const _expandOutcomePairsTo = expandOutcomePairsToSigns(betBoards),
    _expandOutcomePairsTo2 = _slicedToArray(_expandOutcomePairsTo, 2),
    signs = _expandOutcomePairsTo2[0],
    reduction = _expandOutcomePairsTo2[1];
  gameBoard.boards.boardData = {
    boards,
    signs,
    reduction
  };
  return gameBoard;
};

const normalizeSROWScoreBoards = _ref0 => {
  let betProperties = _ref0.betProperties,
    eventTypeId = _ref0.eventTypeId,
    restProductBet = _ref0.restProductBet,
    scoreBoards = _ref0.scoreBoards,
    systemType = _ref0.systemType;
  const gameBoard = _objectSpread({
    boards: {
      betProperties: betProperties || [],
      systemType
    }
  }, restProductBet);

  const srowsAsOutcomePairs = scoreBoards.map(board => {
    const outcomePair = [];
    for (let i = 0; i < board.boardData.length; i += 2) {
      outcomePair.push([board.boardData[i][0], board.boardData[i + 1][0]]);
    }
    return outcomePair;
  });

  const boards = compressSROWToHex(srowsAsOutcomePairs, {
    eventTypeId
  });
  gameBoard.boards.boardData = {
    boards
  };
  return gameBoard;
};
const normalizeGameBoards = _ref1 => {
  let productBet = _ref1.productBet,
    systemType = _ref1.systemType,
    productId = _ref1.productId;
  const betProperties = productBet.betProperties,
    er1X2BoardData = productBet.er1X2BoardData,
    game1X2Boards = productBet.game1X2Boards,
    scoreBoards = productBet.scoreBoards,
    erScoreBoardData = productBet.erScoreBoardData,
    expertenBoardData = productBet.expertenBoardData,
    restProductBet = _objectWithoutProperties(productBet, _excluded3);
  const eventTypeId = getDefinitionByProduct(productId).outcomes.eventTypeId;
  if (betProperties.some(betProperty => ER_BOARDS.includes(betProperty))) {
    if (eventTypeId === EventTypeId.RESULT) {
      return normalizeErBoardsScore({
        betBoards: erScoreBoardData,
        betProperties,
        productBet: restProductBet,
        productId,
        eventTypeId
      });
    }
    return normalizeErBoards({
      betBoards: er1X2BoardData || erScoreBoardData,
      betProperties,
      productBet: restProductBet,
      productId
    });
  }
  if (eventTypeId === EventTypeId.RESULT && betProperties.some(betProperty => EXPERTEN_BOARDS.includes(betProperty))) {
    return normalizeScoreBoardWithOutcomePairs({
      betBoards: expertenBoardData.eventResults,
      betProperties,
      productBet: restProductBet,
      eventTypeId
    });
  }
  if (eventTypeId === EventTypeId.RESULT && (scoreBoards === null || scoreBoards === void 0 ? void 0 : scoreBoards.length) > 1) {
    return normalizeSROWScoreBoards({
      betProperties,
      eventTypeId,
      restProductBet,
      scoreBoards,
      systemType
    });
  }

  if (eventTypeId === EventTypeId.RESULT) {
    return normalizeScoreBoard({
      betBoards: scoreBoards,
      betProperties,
      productBet: restProductBet,
      systemType
    });
  }

  if (MSYS_LIKE_BOARDS.includes(systemType)) {
    return normalizeMURBoards({
      betBoards: scoreBoards || game1X2Boards,
      betProperties,
      productBet: restProductBet,
      systemType,
      productId
    });
  }
  if (systemType === wagerSystemTypes.SROW) {
    return normalizeSROWBoards({
      betBoards: scoreBoards || game1X2Boards,
      productBet: restProductBet,
      systemType,
      productId
    });
  }
  throw new Error('Unsuported system wager');
};
const normalizeWager = (wagerData, competition) => {
  const currentAddonDrawNumber = wagerData.currentAddonDrawNumber,
    currentDrawNumber = wagerData.currentDrawNumber,
    extraDescription = wagerData.extraDescription,
    productId = wagerData.productId,
    systemType = wagerData.systemType,
    wager = wagerData.wager,
    wins = wagerData.wins,
    completedDraws = wagerData.completedDraws,
    restWager = _objectWithoutProperties(wagerData, _excluded4);
  const productIdAsNumber = products.resolveProductId(productId);
  const currentDrawNumberInt = parseInt(currentDrawNumber, 10);
  let compType;
  let compDesc;
  if (competition) {
    compType = competition.getCompType();
    compDesc = competition.getCompetitionDesc();
  }
  let productBet;
  let addonBet;
  wager.bets.forEach(bet => {
    if (isAddonWagerByITSName(bet.productId)) {
      if (addonBet) {
        logger.warn("Addon bet is already set: ".concat(JSON.stringify(addonBet)));
      }
      addonBet = bet;
    } else {
      if (productBet) {
        logger.warn("Product bet is already set: ".concat(JSON.stringify(productBet)));
      }
      productBet = bet;
    }
  });
  delete productBet.productId;
  const _productBet = productBet,
    drawNum = _productBet.drawNum,
    restProductBet = _objectWithoutProperties(_productBet, _excluded5);


  const addonCompletedDrawNumbers = [];
  if (addonBet && completedDraws.length > 0) {
    completedDraws.forEach(draw => {
      if (products.resolveProductId(translateCompletedDrawProductId(draw.productId)) === 30) {
        addonCompletedDrawNumbers.push(draw.drawNumber);
      }
    });
  }
  const addonWin = [];
  const productWin = [];
  (wins || []).forEach(win => {
    if (isAddonWagerByITSName(win.productId)) {
      addonWin.push(_objectSpread(_objectSpread({}, win), {}, {
        winDiv: win.winDiv + 1,
        productId: products.resolveProductId(win.productId)
      }));
    } else {
      productWin.push(_objectSpread(_objectSpread({}, win), {}, {
        winDiv: win.winDiv + 1,
        productId: products.resolveProductId(win.productId)
      }));
    }
  });
  const normalizedCompletedDraws = completedDraws.map(draw => _objectSpread(_objectSpread({}, draw), {}, {
    productId: products.resolveProductId(translateCompletedDrawProductId(draw.productId))
  }));
  const normalizedWager = {
    productBet: _objectSpread({
      productId: productIdAsNumber,
      drawNumber: drawNum,
      wins: productWin,
      lastCompletedDrawNumber: currentDrawNumberInt,
      completedDraws: normalizedCompletedDraws,
      gameBoard: _objectSpread({}, normalizeGameBoards({
        productBet: restProductBet,
        systemType,
        productId: productIdAsNumber
      })),
      compType,
      compDesc
    }, restWager)
  };
  if (addonBet) {
    normalizedWager.addonBet = _objectSpread(_objectSpread({}, addonBet), {}, {
      wins: addonWin,
      addonCompletedDrawNumbers
    });
  }
  return normalizedWager;
};
setGlobal('svs.components.tipsen.store.helpers.normalizeWager', normalizeWager);

 })(window);